import Hls from 'hls.js';

export function extractResponseCode(data: unknown): number | null {
  if (!data || typeof data !== 'object') return null;
  const d = data as {
    response?: { code?: unknown; status?: unknown };
    networkDetails?: { status?: unknown };
  };

  const candidates = [d.response?.code, d.response?.status, d.networkDetails?.status];
  for (const candidate of candidates) {
    if (typeof candidate === 'number') return candidate;
    if (typeof candidate === 'string') {
      const parsed = Number(candidate);
      if (!Number.isNaN(parsed)) return parsed;
    }
  }
  return null;
}

export function isAccessDeniedError(data: unknown, responseCode: number | null): boolean {
  if (!data || typeof data !== 'object') return false;
  const d = data as { type?: unknown; details?: unknown; reason?: unknown };

  const isNetworkError = d.type === Hls.ErrorTypes.NETWORK_ERROR;
  if (!isNetworkError) return false;
  if (responseCode === 403) return true;

  const marker = `${String(d.details ?? '')} ${String(d.reason ?? '')}`.toLowerCase();
  return marker.includes('403')
    || marker.includes('forbidden')
    || marker.includes('cors')
    || marker.includes('access-control-allow-origin');
}

export function isPlayAbortError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as { name?: unknown; message?: unknown };
  const name = typeof e.name === 'string' ? e.name : '';
  const message = typeof e.message === 'string' ? e.message.toLowerCase() : '';
  return name === 'AbortError' || message.includes('interrupted by a call to pause');
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}
